var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96094 5C8.96094 7.32969 7.06719 9.21875 4.73 9.21875C4.17525 9.21949 3.62578 9.11096 3.11297 8.89935C2.60017 8.68773 2.13406 8.37719 1.74127 7.98544C1.34848 7.5937 1.03669 7.12842 0.823713 6.61618C0.610736 6.10393 0.500738 5.55476 0.5 5C0.5 2.66938 2.39375 0.781255 4.73 0.781255C5.28483 0.780393 5.8344 0.888837 6.34731 1.10039C6.86023 1.31195 7.32645 1.62248 7.71934 2.01424C8.11223 2.40599 8.4241 2.87131 8.63713 3.38362C8.85017 3.89592 8.9602 4.44517 8.96094 5ZM13.6016 5C13.6016 7.19375 12.6547 8.97126 11.4866 8.97126C10.3184 8.97126 9.37156 7.19282 9.37156 5C9.37156 2.80625 10.3184 1.02876 11.4866 1.02876C12.6547 1.02876 13.6016 2.80719 13.6016 5ZM15.5 5C15.5 6.965 15.1672 8.55782 14.7556 8.55782C14.345 8.55782 14.0122 6.96407 14.0122 5C14.0122 3.035 14.345 1.44219 14.7566 1.44219C15.1672 1.44219 15.5 3.035 15.5 5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.05ca782c.svg";
export { ForwardRef as ReactComponent };